module.exports = __webpack_public_path__ + "4ad32a060702606c0191d4fd61b0ff9d.png";